/* Native details navigation; works after Shopify editor section reloads. */
document.addEventListener('click', (event) => {
  document.querySelectorAll('.catchii-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.catchii-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('toggle', (event) => {
  const target = event.target;
  if (!target.matches?.('.catchii-menu') || !target.open) return;
  document.querySelectorAll('.catchii-menu[open]').forEach((menu) => {
    if (menu !== target) menu.open = false;
  });
}, true);

// Ask Shopify to sort the entire catalog before taking the homepage limit.
// Sorting a local Liquid array alone would only cover its first product page.
async function catchiiLoadLatest(scope = document) {
  const rows = scope.querySelectorAll('[data-catchii-latest]');
  for (const row of rows) {
    if (row.dataset.latestLoading === 'true') continue;
    row.dataset.latestLoading = 'true';
    try {
      const url = new URL(row.dataset.latestUrl, window.location.origin);
      if (url.origin !== window.location.origin) continue;
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Latest products unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = doc.querySelector('.catchii-product-grid');
      const current = row.querySelector('.catchii-product-grid');
      if (!incoming || !current) continue;
      const limit = Number(row.dataset.limit) || 4;
      Array.from(incoming.children).slice(limit).forEach((card) => card.remove());
      current.replaceChildren(...Array.from(incoming.children));
    } catch (error) {
      // Keep the server-rendered cards and the sorted full-catalog link usable.
    } finally {
      delete row.dataset.latestLoading;
    }
  }
}
catchiiLoadLatest();
document.addEventListener('shopify:section:load', (event) => catchiiLoadLatest(event.target));

// Open desktop menus on hover, including newly loaded theme-editor sections.
function catchiiSetupHover(scope = document) {
  const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
  scope.querySelectorAll('.catchii-menu, .catchii-submenu').forEach((menu) => {
    if (menu.dataset.hoverReady) return;
    menu.dataset.hoverReady = 'true';
    let closeTimer;
    menu.addEventListener('pointerenter', () => {
      if (!hoverDevice.matches) return;
      clearTimeout(closeTimer);
      menu.open = true;
    });
    menu.addEventListener('pointerleave', () => {
      if (!hoverDevice.matches) return;
      closeTimer = setTimeout(() => {
        if (!menu.contains(document.activeElement)) menu.open = false;
      }, 180);
    });
    menu.addEventListener('focusin', () => {
      clearTimeout(closeTimer);
      menu.open = true;
    });
    menu.addEventListener('focusout', () => {
      closeTimer = setTimeout(() => {
        if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false;
      }, 180);
    });
  });
}
catchiiSetupHover();
document.addEventListener('shopify:section:load', (event) => catchiiSetupHover(event.target));

// Nested flyouts close their siblings; closing a parent resets its children.
document.addEventListener('toggle', (event) => {
  const menu = event.target;
  if (!menu.matches?.('.catchii-menu, .catchii-submenu')) return;
  if (!menu.open) {
    menu.querySelectorAll('.catchii-submenu[open]').forEach(child => child.open = false);
  } else if (menu.matches('.catchii-submenu')) {
    Array.from(menu.parentElement.children).forEach(sibling => {
      if (sibling !== menu && sibling.matches('.catchii-submenu')) sibling.open = false;
    });
  }
}, true);

// Mobile category disclosure; desktop navigation remains visible.
function catchiiSetupMobileMenu(scope = document) {
  scope.querySelectorAll('.catchii-mobile-menu-toggle').forEach((button) => {
    if (button.dataset.mobileMenuReady) return;
    const header = button.closest('.catchii-header');
    const navigation = header?.querySelector('.catchii-navigation');
    if (!navigation) return;
    button.dataset.mobileMenuReady = 'true';
    const mobile = window.matchMedia('(max-width: 700px)');
    const setOpen = (open, returnFocus = false) => {
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
      navigation.classList.toggle('is-mobile-open', open);
      if (!open) navigation.querySelectorAll('details[open]').forEach((item) => { item.open = false; });
      if (returnFocus) button.focus();
    };
    button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setOpen(false, true);
      }
    });
    navigation.addEventListener('click', (event) => {
      if (mobile.matches && event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('click', (event) => {
      if (mobile.matches && !header.contains(event.target)) setOpen(false);
    });
    mobile.addEventListener('change', () => setOpen(false));
  });
}
catchiiSetupMobileMenu();
document.addEventListener('shopify:section:load', (event) => catchiiSetupMobileMenu(event.target));

// Keep the search hint short on phones and preserve the desktop wording.
function catchiiSetupSearchPlaceholder(scope = document) {
  const mobile = window.matchMedia('(max-width: 700px)');
  scope.querySelectorAll('[data-catchii-placeholder-mobile]').forEach((input) => {
    if (input.dataset.catchiiPlaceholderReady) return;
    input.dataset.catchiiPlaceholderReady = 'true';
    const update = () => {
      input.placeholder = mobile.matches ? input.dataset.catchiiPlaceholderMobile : input.dataset.catchiiPlaceholderDesktop;
    };
    update();
    mobile.addEventListener('change', update);
  });
}
catchiiSetupSearchPlaceholder();
document.addEventListener('shopify:section:load', (event) => catchiiSetupSearchPlaceholder(event.target));
